<div class="container">
  <button mat-icon-button class="close" (click)="close()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <div class="image-container">
    <img [src]="imageUrl" />
  </div>
</div>
